import React from "react";
import { Box } from "@mui/material";

export type SidebarBaseProps = {
  children: React.ReactNode;
  width?: number;
};

export function SidebarBase({ children, width = 72 }: SidebarBaseProps) {
  return (
    <Box
      sx={{
        width,
        flexShrink: 0,
        height: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        backgroundColor: "#ECEFF1",
        borderRight: "1px solid #E0E0E0",
      }}
    >
      {children}
    </Box>
  );
}
